import ElDraggable from './src/draggable'

export default ElDraggable

export * from './src/draggable'
